export const collator = new Intl.Collator(undefined, { sensitivity: 'accent' })

export const updateIn = (path = [], mutator, obj) => {
  if (!path.length) return obj
  const lastIndex = path.length - 1
  let node = obj
  for (const [index, p] of path.entries()) {
    if (lastIndex != index && 'object' != typeof node[p]) {
      node[p] = {}
    } else if (lastIndex == index) {
      node[p] = mutator(node[p])
    }
    node = node[p]
  }
  return obj
}

export const setIn = (path = [], value, obj) => updateIn(path, () => value, obj)

export const getIn = (path = [], obj) => {
  if (!path.length) return obj
  const lastIndex = path.length - 1
  let node = obj
  for (let index = 0; index < lastIndex; index++) {
    const p = path[index]
    if ('object' != typeof node[p]) return void 0
    node = node[p]
  }
  return node[path[lastIndex]]
}

export const uniq = array => array.filter((element, index, array) => array.indexOf(element) == index)

export const is = Type => target => (null != target && target.constructor === Type) || target instanceof Type

export const assocPathRecur = (path, value, obj = {}, index = 0) =>
  Object.assign({}, is(Object, obj) ? obj : {}, {
    [path[index]]: index == path.length - 1 ? value : assocPathRecur(path, value, obj[path[index]], index + 1)
  })

export const assocPath = (path, value) => obj => assocPathRecur(path, value, obj, 0)

export const omit = (properties = [], obj) =>
  Object.keys(obj).reduce(
    (omitted, property) => (properties.includes(property) ? omitted : ((omitted[property] = obj[property]), omitted)),
    {}
  )

export const pick = (properties = [], obj) =>
  properties.reduce((picked, property) => ((picked[property] = obj[property]), picked), {})

export const casecmp = (a, b) =>
  is(String)(a) && is(String)(b) ? 0 == collator.compare(a, b) : is(Array)(a) && is(Array)(b) ? arraycmp(a, b) : a == b

export function arraycmp(a, b) {
  return a.length == b.length && a.reduce((res, v, i) => res && casecmp(v, b[i]), true)
}

export const createErrorType = (name, initFunction) => {
  function E(message, data = null) {
    this.message = message
    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, this.constructor)
    } else {
      this.stack = new Error('stack').stack
    }
    if (null != data) {
      this.data = data
    }
    initFunction && initFunction.apply(this, arguments)
  }
  E.prototype = Object.create(Error.prototype)
  E.prototype.name = name
  E.prototype.constructor = E
  return E
}

export const toPrecision = precision => {
  const precisionMod = Math.pow(10, precision)
  return value => Math.round(precisionMod * value) / precisionMod
}

export const escapeRegExp = string => string.replace(/[$()*+.?[\\\]^{|}]/g, '\\$&')
export const getSize = obj => Math.round(JSON.stringify(obj).length / 1024)

export const generateUID = () => {
  const timestamp = (Number(Date.now()) - Number(new Date(2017, 9, 1))).toString(36)
  const number = Math.round(Math.random() * 100000).toString(36)

  return timestamp + number
}

export const encodeText = (text, brack = true) => {
  if (text == undefined || null === text) return null
  let newText = (text != undefined && null !== text && String(text)) || ''
  newText = newText.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
  return brack ? newText.replace(/\[/g, '&lbrack;').replace(/]/g, '&rbrack;') : newText
}
export const decodeText = (text, brack = true) => {
  if (text == undefined || null === text) return null
  let newText = (text != undefined && null !== text && String(text)) || ''
  newText = brack ? newText.replace(/&lbrack;/g, '[').replace(/&rbrack;/g, ']') : newText
  return newText.replace(/&lt;/g, '<').replace(/&gt;/g, '>').replace(/&amp;/g, '&')
}

const round = (v, d = 0) => {
  const tenPow = Math.pow(10, d)
  return Math.round(v * tenPow) / tenPow
}

export const formatAmounts = (r, attr, n = 2) => {
  let res = 0

  if (r != undefined && null !== r) {
    if (attr == undefined || null === attr) {
      if ('string' == typeof r) return r
      if (r != Math.round(r)) res = round(r, n).toFixed(n)
      else return String(r)
    }

    const _attr = Array.isArray(attr) ? attr.find(a => r[a] != undefined && null !== r[a]) : attr

    if (_attr != undefined && null !== _attr) {
      if (r[_attr] == undefined || null === r[_attr]) return '0'
      if ('string' == typeof r[_attr]) return r[_attr]
      if (r[_attr] != Math.round(r[_attr])) res = round(r[_attr], n).toFixed(n)
      else return String(r[_attr])
    }
  }

  return (0 === Number(res) && '0') || res || '0'
}

export const plural = (n, one, many) => (1 === n ? one : many)
